module.exports = __webpack_public_path__ + "img/feature_protocol.53e0fe94.png";